import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 15,
	viewBox: "0 0 400 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			y1: -.5,
			x2: 171.999,
			y2: -.5,
			transform: "matrix(0.999999 0.00124688 0.00309213 0.999995 0 7.39258)",
			stroke: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.876 10.108C190.232 10.108 189.032 8.896 189.032 7C189.032 5.104 190.232 3.892 191.876 3.892C192.848 3.892 193.664 4.324 194.156 5.068V4H195.404V10H194.156V8.932C193.664 9.676 192.848 10.108 191.876 10.108ZM192.26 8.956C193.436 8.956 194.216 8.212 194.216 7C194.216 5.788 193.436 5.044 192.26 5.044C191.072 5.044 190.292 5.788 190.292 7C190.292 8.212 191.072 8.956 192.26 8.956ZM200.352 4.216C202.212 4.216 203.412 5.416 203.412 7.18C203.412 8.968 201.96 10.12 200.196 10.12C198.204 10.12 196.872 8.728 196.872 6.244C196.872 3.772 198.252 2.344 200.304 2.092C201.12 1.984 201.78 1.888 201.816 1.468H202.98C202.968 2.704 201.972 3.064 200.364 3.244C198.972 3.4 198.12 4.12 197.892 5.524L197.916 5.536C198.36 4.78 199.224 4.216 200.352 4.216ZM198.264 7.144C198.264 8.332 199.056 8.98 200.22 8.98C201.384 8.98 202.176 8.332 202.176 7.144C202.176 5.956 201.396 5.296 200.232 5.296C199.056 5.296 198.264 5.956 198.264 7.144ZM207.706 3.892C209.59 3.892 210.97 5.104 210.97 7C210.97 8.896 209.59 10.108 207.706 10.108C205.81 10.108 204.43 8.896 204.43 7C204.43 5.14 205.738 3.892 207.706 3.892ZM207.706 5.044C206.494 5.044 205.69 5.8 205.69 7C205.69 8.212 206.494 8.956 207.706 8.956C208.918 8.956 209.71 8.212 209.71 7C209.71 5.788 208.918 5.044 207.706 5.044Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.5,
			x2: 171.999,
			y2: -.5,
			transform: "matrix(0.999999 0.00124688 0.00309213 0.999995 228 7.39258)",
			stroke: "#A0A0A0"
		})
	]
});
export default SvgOrIcon;
